import { render, staticRenderFns } from "./AdminWarningManagement.vue?vue&type=template&id=5f550fb0"
import script from "./AdminWarningManagement.vue?vue&type=script&lang=js"
export * from "./AdminWarningManagement.vue?vue&type=script&lang=js"
import style0 from "./AdminWarningManagement.vue?vue&type=style&index=0&id=5f550fb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports